// @ts-nocheck

import React from "react";
import IntegrationSettingsTab from "./IntegrationSettingsTab";

const CommunicationIntegrationsModule: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Communication Integrations</h1>
          <p className="text-muted-foreground">
            Configure and manage external communication service integrations
          </p>
        </div>
      </div>

      <IntegrationSettingsTab />
    </div>
  );
};

export default CommunicationIntegrationsModule;
